import React from 'react';

export const PlayerControl = ({isPlaying, onPlayPause, onNextTrack, onPrevTrack}) => {
    return (
        <div className="player-control">
            <div className="prev-icon" onClick={onPrevTrack}></div>
            {!isPlaying &&
                <div className="play-icon" onClick={onPlayPause}></div>
            }
            {isPlaying &&
                <div className="pause-icon" onClick={onPlayPause}></div>
            }
            <div className="next-icon" onClick={onNextTrack}></div>
        </div>
    );
}